"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMIL InsuranceService
 * The EMIL InsuranceService API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadStatusesApi = exports.LeadStatusesApiFactory = exports.LeadStatusesApiFp = exports.LeadStatusesApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * LeadStatusesApi - axios parameter creator
 * @export
 */
var LeadStatusesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This will create a lead status. There are 3 predefined lead statuses in our service, but tenants can define their own custom lead statuses as well. Predefined lead statuses are \"created\",\"approved\" and \"declined\".
         * @summary Create the lead status
         * @param {CreateLeadStatusRequestDto} createLeadStatusRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadStatus: function (createLeadStatusRequestDto, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createLeadStatusRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('createLeadStatus', 'createLeadStatusRequestDto', createLeadStatusRequestDto);
                            localVarPath = "/insuranceservice/v1/lead-statuses";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createLeadStatusRequestDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Permanently deletes the lead status. Supply the unique id that was returned when you      created the lead status and this will delete it. Deleting a lead status can have an impact on workflows,     and it\'s crucial to ensure that no workflows are using the lead status that is being deleted.
         * @summary Delete the lead status
         * @param {number} id
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLeadStatus: function (id, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteLeadStatus', 'id', id);
                            localVarPath = "/insuranceservice/v1/lead-statuses/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves the details of the lead status that was previously created. Supply the unique lead status code        that was returned when you created it and Emil Api will return the corresponding lead status information.
         * @summary Retrieve the lead status
         * @param {number} id
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadStatus: function (id, authorization, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getLeadStatus', 'id', id);
                            localVarPath = "/insuranceservice/v1/lead-statuses/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of lead statuses you have previously created.        The lead statuses are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
         * @summary List lead statuses
         * @param {string} [authorization] Bearer Token
         * @param {any} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {any} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1,     your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {any} [filter] Filter the response by one or multiple fields.     In general, fetching filtered responses will conserve bandwidth and reduce response time.
         * @param {any} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {any} [order] The order parameter determines how the results should be sorted according to a specified field.     It functions similarly to an SQL ORDER BY.     Sorting can be performed in either ascending (ASC) or descending (DESC) order.     Default: ASC.
         * @param {any} [expand] Use this parameter to fetch additional information about the list items.     The expand query parameter increases the set of fields that appear in the response in     addition to the default ones.     Expanding resources can reduce the number of API calls required to accomplish a task.     However, use this with parsimony as some expanded fields can drastically increase payload size.
         * @param {any} [filters] Filters the response by one or multiple fields.          Advanced filter functionality allows you to perform more complex filtering operations.          In general, fetching filtered responses conserves bandwidth and reduces response time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLeadStatuses: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, baseAccessToken, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/insuranceservice/v1/lead-statuses";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                                baseAccessToken = configuration.accessToken;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (pageSize !== undefined) {
                                localVarQueryParameter['pageSize'] = pageSize;
                            }
                            if (pageToken !== undefined) {
                                localVarQueryParameter['pageToken'] = pageToken;
                            }
                            if (filter !== undefined) {
                                localVarQueryParameter['filter'] = filter;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (expand !== undefined) {
                                localVarQueryParameter['expand'] = expand;
                            }
                            if (filters !== undefined) {
                                localVarQueryParameter['filters'] = filters;
                            }
                            if (authorization !== undefined && authorization !== null || baseAccessToken !== undefined && baseAccessToken !== null) {
                                localVarHeaderParameter['Authorization'] = String(authorization ? authorization : baseAccessToken);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LeadStatusesApiAxiosParamCreator = LeadStatusesApiAxiosParamCreator;
/**
 * LeadStatusesApi - functional programming interface
 * @export
 */
var LeadStatusesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LeadStatusesApiAxiosParamCreator)(configuration);
    return {
        /**
         * This will create a lead status. There are 3 predefined lead statuses in our service, but tenants can define their own custom lead statuses as well. Predefined lead statuses are \"created\",\"approved\" and \"declined\".
         * @summary Create the lead status
         * @param {CreateLeadStatusRequestDto} createLeadStatusRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadStatus: function (createLeadStatusRequestDto, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLeadStatus(createLeadStatusRequestDto, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Permanently deletes the lead status. Supply the unique id that was returned when you      created the lead status and this will delete it. Deleting a lead status can have an impact on workflows,     and it\'s crucial to ensure that no workflows are using the lead status that is being deleted.
         * @summary Delete the lead status
         * @param {number} id
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLeadStatus: function (id, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteLeadStatus(id, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Retrieves the details of the lead status that was previously created. Supply the unique lead status code        that was returned when you created it and Emil Api will return the corresponding lead status information.
         * @summary Retrieve the lead status
         * @param {number} id
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadStatus: function (id, authorization, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLeadStatus(id, authorization, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of lead statuses you have previously created.        The lead statuses are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
         * @summary List lead statuses
         * @param {string} [authorization] Bearer Token
         * @param {any} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {any} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1,     your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {any} [filter] Filter the response by one or multiple fields.     In general, fetching filtered responses will conserve bandwidth and reduce response time.
         * @param {any} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {any} [order] The order parameter determines how the results should be sorted according to a specified field.     It functions similarly to an SQL ORDER BY.     Sorting can be performed in either ascending (ASC) or descending (DESC) order.     Default: ASC.
         * @param {any} [expand] Use this parameter to fetch additional information about the list items.     The expand query parameter increases the set of fields that appear in the response in     addition to the default ones.     Expanding resources can reduce the number of API calls required to accomplish a task.     However, use this with parsimony as some expanded fields can drastically increase payload size.
         * @param {any} [filters] Filters the response by one or multiple fields.          Advanced filter functionality allows you to perform more complex filtering operations.          In general, fetching filtered responses conserves bandwidth and reduces response time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLeadStatuses: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listLeadStatuses(authorization, pageSize, pageToken, filter, search, order, expand, filters, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LeadStatusesApiFp = LeadStatusesApiFp;
/**
 * LeadStatusesApi - factory interface
 * @export
 */
var LeadStatusesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LeadStatusesApiFp)(configuration);
    return {
        /**
         * This will create a lead status. There are 3 predefined lead statuses in our service, but tenants can define their own custom lead statuses as well. Predefined lead statuses are \"created\",\"approved\" and \"declined\".
         * @summary Create the lead status
         * @param {CreateLeadStatusRequestDto} createLeadStatusRequestDto
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadStatus: function (createLeadStatusRequestDto, authorization, options) {
            return localVarFp.createLeadStatus(createLeadStatusRequestDto, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Permanently deletes the lead status. Supply the unique id that was returned when you      created the lead status and this will delete it. Deleting a lead status can have an impact on workflows,     and it\'s crucial to ensure that no workflows are using the lead status that is being deleted.
         * @summary Delete the lead status
         * @param {number} id
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLeadStatus: function (id, authorization, options) {
            return localVarFp.deleteLeadStatus(id, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the details of the lead status that was previously created. Supply the unique lead status code        that was returned when you created it and Emil Api will return the corresponding lead status information.
         * @summary Retrieve the lead status
         * @param {number} id
         * @param {string} [authorization] Bearer Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadStatus: function (id, authorization, options) {
            return localVarFp.getLeadStatus(id, authorization, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of lead statuses you have previously created.        The lead statuses are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
         * @summary List lead statuses
         * @param {string} [authorization] Bearer Token
         * @param {any} [pageSize] A limit on the number of objects to be returned.     Limit ranges between 1 and 50. Default: 10.
         * @param {any} [pageToken] A cursor for use in pagination.     pageToken is an ID that defines your place in the list.     For instance, if you make a list request and receive 100 objects and pageToken&#x3D;1,     your subsequent call can include pageToken&#x3D;2 in order to fetch the next page of the list.
         * @param {any} [filter] Filter the response by one or multiple fields.     In general, fetching filtered responses will conserve bandwidth and reduce response time.
         * @param {any} [search] To search the list by any field, pass search&#x3D;xxx to fetch the result.
         * @param {any} [order] The order parameter determines how the results should be sorted according to a specified field.     It functions similarly to an SQL ORDER BY.     Sorting can be performed in either ascending (ASC) or descending (DESC) order.     Default: ASC.
         * @param {any} [expand] Use this parameter to fetch additional information about the list items.     The expand query parameter increases the set of fields that appear in the response in     addition to the default ones.     Expanding resources can reduce the number of API calls required to accomplish a task.     However, use this with parsimony as some expanded fields can drastically increase payload size.
         * @param {any} [filters] Filters the response by one or multiple fields.          Advanced filter functionality allows you to perform more complex filtering operations.          In general, fetching filtered responses conserves bandwidth and reduces response time.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLeadStatuses: function (authorization, pageSize, pageToken, filter, search, order, expand, filters, options) {
            return localVarFp.listLeadStatuses(authorization, pageSize, pageToken, filter, search, order, expand, filters, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LeadStatusesApiFactory = LeadStatusesApiFactory;
/**
 * LeadStatusesApi - object-oriented interface
 * @export
 * @class LeadStatusesApi
 * @extends {BaseAPI}
 */
var LeadStatusesApi = /** @class */ (function (_super) {
    __extends(LeadStatusesApi, _super);
    function LeadStatusesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This will create a lead status. There are 3 predefined lead statuses in our service, but tenants can define their own custom lead statuses as well. Predefined lead statuses are \"created\",\"approved\" and \"declined\".
     * @summary Create the lead status
     * @param {LeadStatusesApiCreateLeadStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadStatusesApi
     */
    LeadStatusesApi.prototype.createLeadStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LeadStatusesApiFp)(this.configuration).createLeadStatus(requestParameters.createLeadStatusRequestDto, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Permanently deletes the lead status. Supply the unique id that was returned when you      created the lead status and this will delete it. Deleting a lead status can have an impact on workflows,     and it\'s crucial to ensure that no workflows are using the lead status that is being deleted.
     * @summary Delete the lead status
     * @param {LeadStatusesApiDeleteLeadStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadStatusesApi
     */
    LeadStatusesApi.prototype.deleteLeadStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LeadStatusesApiFp)(this.configuration).deleteLeadStatus(requestParameters.id, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the details of the lead status that was previously created. Supply the unique lead status code        that was returned when you created it and Emil Api will return the corresponding lead status information.
     * @summary Retrieve the lead status
     * @param {LeadStatusesApiGetLeadStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadStatusesApi
     */
    LeadStatusesApi.prototype.getLeadStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LeadStatusesApiFp)(this.configuration).getLeadStatus(requestParameters.id, requestParameters.authorization, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of lead statuses you have previously created.        The lead statuses are returned in sorted order, with the oldest one appearing first.        For more information about pagination, read the Pagination documentation.
     * @summary List lead statuses
     * @param {LeadStatusesApiListLeadStatusesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadStatusesApi
     */
    LeadStatusesApi.prototype.listLeadStatuses = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.LeadStatusesApiFp)(this.configuration).listLeadStatuses(requestParameters.authorization, requestParameters.pageSize, requestParameters.pageToken, requestParameters.filter, requestParameters.search, requestParameters.order, requestParameters.expand, requestParameters.filters, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LeadStatusesApi;
}(base_1.BaseAPI));
exports.LeadStatusesApi = LeadStatusesApi;
